/* eslint-disable eag/match-named-export */
/* tslint:disable */
// this is an auto generated file. This will be overwritten
import * as APITypes from '../API';

type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const sendEvent = /* GraphQL */ `mutation SendEvent(
  $conversationId: ID!
  $id: ID!
  $tenantId: ID!
  $type: Type!
  $userId: ID!
) {
  sendEvent(
    conversationId: $conversationId
    id: $id
    tenantId: $tenantId
    type: $type
    userId: $userId
  ) {
    conversationId
    id
    tenantId
    type
    userId
    __typename
  }
}
` as GeneratedMutation<APITypes.SendEventMutationVariables, APITypes.SendEventMutation>;
